import Footer from "../footer";
import NavBar from "../nav";

const NoPage = () => {
  return <div>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>404: Page Not Found</h1>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default NoPage;